import { memo, useReducer, createContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// @mui
import { useTheme } from '@mui/material/styles';
import {
  Box,
  IconButton, Tooltip, Typography,
} from '@mui/material';

// components

//
import NotificationDetails from './NotificationDetails';
import NotificationList from './NotificationList';

/* ======================================================================================== */

const NotificationContext = createContext({});

const initialValues = {
  open: false,
  visible: false,
  details: {},
  reply_details: {},
  readFlag: null
};

function reducer(state, action) {
  switch (action.type) {
    case 'OPEN_LIST_DRAWER':
      return action.data;
    case 'OPEN_DETAILS_DRAWER':
      return action.data;
    default:
      return initialValues;
  }
};

/* ======================================================================================== */


const Notifications = ({ primary, children }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();


  const [state, commit] = useReducer(reducer, { initialValues });

  const toggleListDrawer = (visible) => (event) => {
    commit({
      type: 'OPEN_LIST_DRAWER',
      data: { open: visible }
    });
  };

  return (
    <NotificationContext.Provider value={{ state, commit }}>
      <NotificationList ct={NotificationContext} />
      <NotificationDetails ct={NotificationContext} />
    </NotificationContext.Provider>
  );
};

export default memo(Notifications);
